import { CartProductItem } from '../types'

export const getTotalPriceByCart = (cartList: CartProductItem[]): number =>
  cartList.reduce((acc, item: CartProductItem) => {
    const discountPrice = item.discountPrice ? Number(item.discountPrice) : 0
    const quantity = item.quantity ? Number(item.quantity) : 1
    return acc + discountPrice * quantity
  }, 0)
